import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationSettingsRoutingModule } from './location-settings-routing.module';
import { LocationSettingsComponent } from './location-settings/location-settings.component';
import { MaterialModule } from '@huge-monorepo/shared/modules';

@NgModule({
  declarations: [LocationSettingsComponent],
  imports: [CommonModule, LocationSettingsRoutingModule, MaterialModule],
})
export class LocationSettingsModule {}
